var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.env === 'production')?_c('p',[_vm._v("Redirecting to login page...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }